// extracted by mini-css-extract-plugin
module.exports = {"termsTitle":"ReturnsTermsAndConditions-module__termsTitle","termsContent":"ReturnsTermsAndConditions-module__termsContent"};